import { Select, Space } from "antd";
import React, { useContext, useEffect, useState } from "react";
import trans from "../../../utils";
import { popupcontext } from "../../../context/Popupscontext";
import Popup from "../../Helpers/Popup/Popup";
import { Modal } from "react-bootstrap";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../Helpers/CloseBtn/Close";
import { toast } from "react-toastify";
import {
  useGetAllTeamsQuery,
  useEditTeamMutation,
  useGetSpecificMemberQuery,
  useAssignMemberToTeamMutation,
  useUnassignMemberFromTeamMutation,
} from "../../../Redux/service/Teams/Teams";

export default function AssignMemberToTeamsPopup() {
  const {
    isAssigningMemberToTeams,
    setIsAssigningMemberToTeams,
    activeMemberForTeams,
  } = useContext(popupcontext);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [teams, setTeams] = useState([]);
  const [assignMemberToTeam] = useAssignMemberToTeamMutation();
  const [unassignMemberFromTeam] = useUnassignMemberFromTeamMutation();
  // Fetch all teams
  const { data: allTeamsData, refetch: refetchTeams } = useGetAllTeamsQuery(
    {
      page: 1,
      limit: 10000,
      queryString: "&status=ACTIVE",
    },
    { refetchOnMountOrArgChange: true }
  );

  // Fetch member details
  const { data: memberData, refetch: refetchMember } = useGetSpecificMemberQuery(
    activeMemberForTeams?.id,
    {
      skip: !activeMemberForTeams?.id,
      refetchOnMountOrArgChange: true,
    }
  );

  const handleDropdownVisibleChange = (visible) => {
    if (visible) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  };

  // Get teams that the member is already assigned to
  useEffect(() => {
    if (isAssigningMemberToTeams && memberData?.data?.teamMemberships && activeMemberForTeams?.id) {
      const teamIds = memberData.data.teamMemberships.map((team) => team.teamId);
      setSelectedTeams(teamIds || []);
    } else if (!isAssigningMemberToTeams) {
      // Only clear when popup is closed
      setSelectedTeams([]);
    }
  }, [memberData?.data?.teamMemberships, activeMemberForTeams?.id, isAssigningMemberToTeams]);

  // Set team options
  useEffect(() => {
    if (allTeamsData?.data) {
      setTeams(
        allTeamsData.data.map((team) => ({
          value: team.id,
          label: `${team.name} (${team.code})`,
        }))
      );
    }
  }, [allTeamsData?.data]);

  const handleAssign = async (teamId) => {
    try {
      await assignMemberToTeam({ teamId, memberId: activeMemberForTeams.id }).unwrap();
      toast.success(trans("Member assigned to team successfully"), {
        autoClose: 800,
        rtl: localStorage.getItem("lang") === "ar",
      });
      await refetchTeams();
      await refetchMember();
    } catch (error) {
      setSelectedTeams((prev) => prev.filter((v) => v !== teamId));
      toast.error(error?.data?.message || trans("Failed to assign member to team"), {
        autoClose: 800,
        rtl: localStorage.getItem("lang") === "ar",
      });
    }
  };

  const handleUnAssign = async (teamId) => {
    try {
      await unassignMemberFromTeam({ teamId, memberId: activeMemberForTeams.id }).unwrap();
      toast.success(trans("Member unassigned from team successfully"), {
        autoClose: 800,
        rtl: localStorage.getItem("lang") === "ar",
      });
      await refetchTeams();
      await refetchMember();
    } catch (error) {
      toast.error(error?.data?.message || trans("Failed to unassign member from team"), {
        autoClose: 800,
        rtl: localStorage.getItem("lang") === "ar",
      });
    }
  };

  // Reset selected teams only when popup closes
  useEffect(() => {
    if (!isAssigningMemberToTeams) {
      // Clear selection when popup closes
      setSelectedTeams([]);
    }
  }, [isAssigningMemberToTeams]);

  // Refetch member data when popup opens to get latest teams
  useEffect(() => {
    if (isAssigningMemberToTeams && activeMemberForTeams?.id) {
      refetchMember();
    }
  }, [isAssigningMemberToTeams, activeMemberForTeams?.id, refetchMember]);

  const memberName = memberData?.data?.name || memberData?.data?.email || "";

  return (
    <Popup show={isAssigningMemberToTeams} size="lg" style={"popup-bodyscroll"}>
      <Modal.Header className="modal-header flex-between">
        <Modal.Title id="contained-modal-title-vcenter">
          <PopupTitle
            headtitle={trans("Assign Teams")}
            subtitle={memberName}
          />
        </Modal.Title>
        <Close
          style="close-32 close"
          close={() => {
            setIsAssigningMemberToTeams(false);
          }}
          img="Close"
        />
      </Modal.Header>
      <Modal.Body className="modal-body-scrollable">
        <div>
          <div className="mult-input-label">{trans("Teams")}</div>
          <Space
            style={{
              width: "100%",
            }}
            direction="vertical"
          >
            <Select
              mode="multiple"
              style={{
                width: "100%",
                marginTop: "8px",
              }}
              maxTagCount={"responsive"}
              placeholder={trans("Please select teams")}
              onSelect={(value) => {
                setSelectedTeams((prev) => [...prev, value]);
                handleAssign(value);
              }}
              onDeselect={(value) => {
                setSelectedTeams((prev) => prev.filter((v) => v !== value));
                handleUnAssign(value);
              }}
              value={selectedTeams}
              options={teams}
              open={isOpen}
              onDropdownVisibleChange={handleDropdownVisibleChange}
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            />
          </Space>
        </div>
      </Modal.Body>
    </Popup>
  );
}
